import { Skeleton } from "antd";
import React, { createPortal, useEffect, useState } from "preact/compat";
import Masonry from "react-masonry-component";
import constants from "../constants";
import designDomain from "../domain/designDomain";
import designService from "../service/designService";
import util, { getPrintCartLink } from "../util";
import FreeProFlag from './FreeProFlag';
import { CloseOutlined } from "@ant-design/icons";

export default function MatchingDesignModal({ templateId, setShowExitWarning, onModalClose }: any) {
  const [loading, setLoading] = useState(false);
  const [templates, setTemplates] = useState([]);

  useEffect(() => {
    setLoading(true);

    designService.getTemplateSets(templateId).then(resp => {
      console.log(resp)
      let temps: [] = resp.data.map((it: any) => new designDomain.Design(it, util.sizes))

      setTemplates(temps);
      setLoading(false);
    })
  }, []);


  function useTemplate(template: any) {
    setShowExitWarning(false)
    window.location.href = constants.appPrefix + '/design?parentId=' + template.id;
  }

  function goToCheckout() {
    setShowExitWarning(false)
    window.location.href = getPrintCartLink() + '?fromTimber=true';
  }

  return createPortal(<div className="matching-design-modal-container">
    <div className="modal-back"></div>
    <div className="modal large matching-design-modal">
      <div className="close-btn" onClick={onModalClose}><CloseOutlined/></div>

      <header className={'modal-header'}>
        <h2>Create a matching design</h2>
      </header>

      {loading ?
        <>
          <Skeleton active />
        </>
        :
        <>
          <div className="content">
            <div className="templates-grid">
              {templates.map((template: any) =>
                <div className="matching-template">
                  <div className="inner">
                    <div className="img-wrap">
                      <FreeProFlag free={template.free} isFreemium={false} />
                      <img loading={"lazy"} onClick={() => useTemplate(template)} src={template.defaultThumbnailPath} />
                    </div>
                    <p>
                      <b>{util.getSizeLabel(template.size)}</b><br />
                      {util.getSizeDimensionsLabel(template.size)}
                    </p>
                  </div>
                </div>
              )}
            </div>
          </div>

          <footer>
            <a className="btn primary go-to-checkout" onClick={() => {goToCheckout()}}>No thanks. Continue to checkout &gt;</a>
          </footer>
        </>
      }
    </div>
  </div>, document.getElementById('modals')!)
}
